import React, { useEffect, useState } from "react";
import { useCart } from "./CartContext";
import { app, db } from "../../Admin/Config/Config";
import Loading from "../../assets/Loading/Loading";
import { useLocation, useNavigate } from 'react-router-dom';
import { useToast } from "../../Toast.jsx/Toast";
import { getFunctions, httpsCallable } from "firebase/functions";
import { doc, getDoc } from "firebase/firestore";

export default function Checkout() {
  const { cart } = useCart();
  const { showSuccess, showWarning } = useToast();
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoValues, setPromoValues] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  // =============================== data promo =============================== //
  useEffect(() => {
    setAppliedPromo(location.state.appliedPromo);
    setPromoValues(location.state.promoValues);
  }, [location]);


  const [taxAmount, settaxAmount] = useState(0);
  useEffect(() => {
    if (cart) {
      let total = 0;
      let taxTotal = 0;
      cart.forEach((item) => {
        total += item.offer_price * item.cart_quantity;
        if (item.tax_applicable === true) {
          taxTotal += item.offer_price * item.cart_quantity;
        }
      });
      const tax = ((taxTotal / 100) * 13).toFixed(2);
      settaxAmount(parseFloat(tax));
      setTotalAmount(parseFloat(total.toFixed(2)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart]);

  // =============================== Apply Promo Code ================================ //

  const applyPromoCode = async (code) => {
    setLoading(true);
    const functions = getFunctions(app, "us-central1");
    const additem = httpsCallable(functions, "placeOrder");
    const reqData = {
      order: true,
      address: location.state.address,
    };
    additem(reqData).then((result) => {
      const data = result.data;
      if (data.code === 200) {
        showSuccess(data.message);
        navigateToCheckout(data.orderId);
      } else {
        showWarning(data.message);
        setLoading(false);
      }
    });
  };
  const navigateToCheckout = async (id) => {
    const docRef = doc(db, "orders", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      navigate("/orderstatus", {
        state: {
          order: { orderId: id, label: "Order placed" },
        },
      });
    }
  };


  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };
  // insrtuctions
  const [instructions, setInstructions] = useState("");
  useEffect(() => {
    const fetchInstructions = async () => {
      const docRef = doc(db, "instructions", "instructions");
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setInstructions(docSnap.data().payment_delivery);
      }
    }
    fetchInstructions();
  }, [])


  // =============================== DELIVERY CHARGES =============================== //
  const [deliveryCharge, setDeliveryCharge] = useState(0);
  useEffect(() => {
    const calculateDeliveyCharge = async (total) => {
      const configDoc = await getDoc(doc(db, "configurations", "delivery_charges"));
      const chargesData = configDoc.data();
      if (chargesData && chargesData.charges) {
        let charge = 0;
        for (const chargeRule of chargesData.charges) {
          if (
            total >= chargeRule.min_amount &&
            total <= chargeRule.max_amount
          ) {
            charge = chargeRule.delivery_charge;
            break;
          }
        }
        return charge;
      }
      return 0;
    };

    const getCharge = async () => {
      const total = parseFloat(totalAmount || 0);
      const charge = await calculateDeliveyCharge(total);
      setDeliveryCharge(charge);
    };
    if (totalAmount) {
      getCharge();
    }
  }, [totalAmount, taxAmount]);
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="min-h-screen bg-gray-50 py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* =============================== HEADER SECTION =============================== */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Checkout</h1>
                  <p className="text-gray-600 mt-1">
                    Review your order and complete your purchase
                  </p>
                </div>
                {cart && cart.length > 0 && (
                  <div className="mt-4 sm:mt-0">
                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800">
                      {cart.length} {cart.length === 1 ? "Item" : "Items"}
                    </span>
                  </div>
                )}
              </div>
            </div>

            {/* =============================== MAIN CONTENT GRID =============================== */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* =============================== CART ITEMS SECTION =============================== */}
              <div className="lg:col-span-2">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                  <div className="p-6 border-b border-gray-200">
                    <h2 className="text-xl font-bold text-gray-900">
                      Order Items
                    </h2>
                  </div>

                  {cart &&
                    cart.map((item, index) => (
                      <div
                        key={item.productId}
                        className={`${index !== 0 ? "border-t border-gray-200" : ""
                          }`}
                      >
                        {/* =============================== OUT OF STOCK BADGE =============================== */}
                        {item.stock < 1 && (
                          <div className="relative">
                            <div className="absolute top-4 left-4 z-10">
                              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200">
                                OUT OF STOCK
                              </span>
                            </div>
                          </div>
                        )}

                        {/* =============================== PRODUCT ITEM CARD =============================== */}
                        <div
                          className={`relative p-6 ${item.stock < 1 ? "opacity-50" : ""
                            }`}
                        >
                          {item.stock < 1 && (
                            <div className="absolute inset-0 bg-white bg-opacity-75 pointer-events-none z-10 rounded-lg"></div>
                          )}

                          <div className="flex flex-col md:flex-row gap-6">
                            {/* =============================== PRODUCT IMAGE =============================== */}
                            <div className="flex-shrink-0">
                              <div className="relative">
                                <div
                                  className={`absolute inset-0 w-24 h-24 md:w-32 md:h-32 bg-gradient-to-r from-gray-200 to-gray-400 animate-pulse rounded-lg ${isLoaded ? "hidden" : "block"
                                    }`}
                                ></div>
                                <div className="w-24 h-24 md:w-32 md:h-32 bg-gray-100 rounded-lg overflow-hidden">
                                  <img
                                    src={item.thumb_url}
                                    alt={item.product_name}
                                    onLoad={handleImageLoad}
                                    className={`w-full h-full object-cover transition-opacity duration-500 ease-in-out ${isLoaded ? "opacity-100" : "opacity-0"
                                      }`}
                                  />
                                </div>
                              </div>
                            </div>

                            {/* =============================== PRODUCT DETAILS =============================== */}
                            <div className="flex-1 min-w-0">
                              <div className="flex justify-between items-start">
                                <div className="flex-1">
                                  {/* Product name and tax indicator */}
                                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                    {item.product_name}
                                    {item.tax_applicable === true && (
                                      <span className="ml-2 inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                                        HST Applicable
                                      </span>
                                    )}
                                  </h3>
                                  <p className="text-sm text-gray-600 mb-3">
                                    {item.brand}
                                  </p>

                                  {/* Quantity and Price */}
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                      <span className="text-sm text-gray-600">
                                        Qty:{" "}
                                        <span className="font-medium text-gray-900">
                                          {item.cart_quantity}
                                        </span>
                                      </span>
                                    </div>

                                    {/* =============================== PRICE DISPLAY =============================== */}
                                    <div className="text-right">
                                      {item.offer_price &&
                                        item.cart_quantity ? (
                                        <p className="text-xl font-bold text-gray-900">
                                          $
                                          {(
                                            parseFloat(item.offer_price) *
                                            parseInt(item.cart_quantity)
                                          ).toFixed(2)}
                                        </p>
                                      ) : null}
                                      <p className="text-sm text-gray-500">
                                        ${item.offer_price} each
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                {/* =============================== CONTINUE SHOPPING LINK =============================== */}
                <div className="mt-6">
                  <a
                    href="/"
                    className="inline-flex items-center text-red-600 hover:text-red-800 font-medium transition-colors"
                  >
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M10 19l-7-7m0 0l7-7m-7 7h18"
                      ></path>
                    </svg>
                    Continue Shopping
                  </a>
                </div>
              </div>

              {/* =============================== ORDER SUMMARY SECTION =============================== */}
              <div className="lg:col-span-1">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 sticky top-8">
                  <h2 className="text-xl font-bold text-gray-900 mb-6">
                    Order Summary
                  </h2>

                  {/* =============================== ITEMS COUNT =============================== */}
                  <div className="flex justify-between items-center py-3 border-b border-gray-200">
                    <span className="text-gray-600">Items ({cart.length})</span>
                    <span className="font-semibold text-gray-900">
                      ${totalAmount}
                    </span>
                  </div>

                  {/* =============================== APPLIED PROMO DISPLAY =============================== */}
                  {appliedPromo && (
                    <div className="mt-4">
                      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                        <div className="flex justify-between items-center">
                          <div>
                            <p className="text-sm font-medium text-green-800">
                              {appliedPromo.code} Applied 🎉
                            </p>
                            <p className="text-xs text-green-600 mt-1">
                              Discount: $
                              {promoValues ? promoValues.discount : 0}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* =============================== DELIVERY ADDRESS =============================== */}
                  <div className="mt-6 border-t border-gray-200 pt-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <svg
                        className="w-5 h-5 text-red-600 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                      Delivery Address
                    </h3>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <p className="text-sm font-medium text-gray-900">
                        {location.state.address.name}
                      </p>
                      <p className="text-sm text-gray-600">
                        {location.state.address.mobile}
                      </p>
                      <p className="text-sm text-gray-600">
                        {location.state.address.email}
                      </p>
                      <p className="text-sm text-gray-600 mt-2">
                        {location.state.address.unit_number &&
                          `${location.state.address.unit_number}, `}
                        {location.state.address.street},{" "}
                        {location.state.address.city},{" "}
                        {location.state.address.zip},{" "}
                        {location.state.address.state},{" "}
                        {location.state.address.country}
                      </p>
                    </div>
                  </div>

                  {/* =============================== PAYMENT METHOD =============================== */}
                  <div className="mt-6 border-t border-gray-200 pt-4">
                    <h3 className="text-lg font-semibold text-gray-900 mb-3 flex items-center">
                      <svg
                        className="w-5 h-5 text-red-600 mr-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                        ></path>
                      </svg>
                      Payment Method
                    </h3>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center">
                        <span className="text-sm font-medium text-gray-900">
                          Cash on Delivery (COD)
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* =============================== INSTRUCTIONS =============================== */}

                  {instructions && (
                    <div className="mt-4">
                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <p className="text-sm text-blue-800 leading-relaxed whitespace-pre-line">
                          {instructions}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* =============================== PRICE BREAKDOWN =============================== */}
                  <div className="mt-6 space-y-3">
                    {/* Subtotal */}
                    <div className="flex justify-between text-sm">
                      <span className="text-gray-600">Subtotal</span>
                      <span className="font-medium text-gray-900">
                        ${totalAmount}
                      </span>
                    </div>

                    {/* HST Tax (if applicable) */}
                    {taxAmount > 0 && (
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">HST</span>
                        <span className="font-medium text-gray-900">
                          ${taxAmount}
                        </span>
                      </div>
                    )}
                    {/* Delivery Charge (if applicable) */}
                    {deliveryCharge > 0 && (
                      <>
                        <div className="flex justify-between text-sm">
                          <span className="text-gray-600">Delivery Charge</span>
                          <span className="font-medium text-gray-900">
                            ${deliveryCharge}
                          </span>
                        </div>
                        <div className="mt-3 bg-blue-50 border border-blue-100 rounded-lg p-3 flex items-start gap-3">
                          <svg
                            className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <p className="text-sm text-blue-700 font-medium leading-tight">
                            Enjoy <span className="font-bold underline decoration-blue-300 decoration-2 underline-offset-2">Free Delivery</span> on orders above <span className="text-red-600 font-bold">$250</span>! Save on shipping by adding more items.
                          </p>
                        </div>
                      </>
                    )}

                    {/* Promo Discount (if applied) */}
                    {promoValues && promoValues.discount > 0 && (
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Discount</span>
                        <span className="font-medium text-green-600">
                          -${promoValues.discount}
                        </span>
                      </div>
                    )}

                    {/* Total Amount */}
                    <div className="border-t border-gray-200 pt-3">
                      <div className="flex justify-between">
                        <span className="text-lg font-bold text-gray-900">
                          Total
                        </span>
                        <span className="text-lg font-bold text-gray-900">
                          $
                          {promoValues
                            ? promoValues.final
                            : (
                              parseFloat(totalAmount) + parseFloat(taxAmount) + parseFloat(deliveryCharge)
                            ).toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* =============================== PLACE ORDER BUTTON =============================== */}
                  <div className="mt-6">
                    <button
                      onClick={() => applyPromoCode()}
                      disabled={
                        cart.some((item) => item.stock < 1) || !instructions
                      }
                      className={`w-full py-3 px-4 rounded-lg font-semibold text-white transition-colors ${cart.some((item) => item.stock < 1) || !instructions
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-red-600 hover:bg-red-700 shadow-sm"
                        }`}
                    >
                      Place Order
                    </button>

                    {/* Out of stock warning */}
                    {cart.some((item) => item.stock < 1) && (
                      <p className="text-red-600 text-sm mt-2 text-center">
                        Some items are out of stock
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}



